export function timeToClockFormat(time: number): string {
  return Intl.DateTimeFormat('sv-SE', {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'Europe/Stockholm',
  }).format(time);
}
